"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchRegion = void 0;
/**
 * 大陆及港澳台countryCode
 */
var COUNTRY_CODE = new Map([['852', 'A000810000'], ['853', 'A000810000'], ['886', 'A000810000']]);
var CHN_CODE = 'A000086000';
/**
 * 根据省市区数据模糊匹配行政区信息
 * @param regionData 省市区行政区数据
 * @param content 搜索内容
 * @param options options
 */
exports.searchRegion = function (regionData, content, options) {
    var searchRegion = [];
    /**
     * 大陆及港澳台全部省份遍历
     */
    regionData.forEach(function (provinceInfo) {
        var searchProvinceRegion = searchFromProvince(provinceInfo, content);
        searchProvinceRegion.length && searchProvinceRegion.forEach(function (provinceData) { return searchRegion.push(provinceData); });
    });
    return searchRegion;
};
/**
 * 根据单省数据匹配市区搜索内容
 * @param provinceInfo 省数据
 * @param content 搜索内容
 */
var searchFromProvince = function (provinceInfo, content) {
    var searchRegion = [];
    /**
     * 如果匹配到省，则直接返回该省对应全部市区列表
     */
    if (provinceInfo.fullName.indexOf(content) > -1) {
        provinceInfo.city.forEach(function (city) {
            if (city.county && city.county.length) {
                city.county.forEach(function (county) { return searchRegion.push({
                    province: provinceInfo.fullName,
                    provinceLocationCode: provinceInfo.locationCode,
                    provinceAreaCode: provinceInfo.areaCode,
                    city: city.fullName,
                    cityLocationCode: city.locationCode,
                    cityAreaCode: city.areaCode,
                    county: county.fullName,
                    countyLocationCode: county.locationCode,
                    countyAreaCode: county.areaCode,
                    countryCode: COUNTRY_CODE.get(provinceInfo.locationCode) || CHN_CODE
                }); });
            }
            else {
                searchRegion.push({
                    province: provinceInfo.fullName,
                    provinceLocationCode: provinceInfo.locationCode,
                    provinceAreaCode: provinceInfo.areaCode,
                    city: city.fullName,
                    cityLocationCode: city.locationCode,
                    cityAreaCode: city.areaCode,
                    county: '',
                    countyLocationCode: '',
                    countyAreaCode: '',
                    countryCode: COUNTRY_CODE.get(provinceInfo.locationCode) || CHN_CODE
                });
            }
        });
        return searchRegion;
    }
    /**
     * 匹配市、区信息
     */
    provinceInfo.city.forEach(function (city) {
        if (city.fullName.indexOf(content) > -1) {
            city.county && city.county.forEach(function (county) { return searchRegion.push({
                province: provinceInfo.fullName,
                provinceLocationCode: provinceInfo.locationCode,
                provinceAreaCode: provinceInfo.areaCode,
                city: city.fullName,
                cityLocationCode: city.locationCode,
                cityAreaCode: city.areaCode,
                county: county.fullName,
                countyLocationCode: county.locationCode,
                countyAreaCode: county.areaCode,
                countryCode: COUNTRY_CODE.get(provinceInfo.locationCode) || CHN_CODE
            }); });
        }
        else {
            city.county && city.county.forEach(function (county) {
                if (county.fullName.indexOf(content) > -1) {
                    searchRegion.push({
                        province: provinceInfo.fullName,
                        provinceLocationCode: provinceInfo.locationCode,
                        provinceAreaCode: provinceInfo.areaCode,
                        city: city.fullName,
                        cityLocationCode: city.locationCode,
                        cityAreaCode: city.areaCode,
                        county: county.fullName,
                        countyLocationCode: county.locationCode,
                        countyAreaCode: county.areaCode,
                        countryCode: COUNTRY_CODE.get(provinceInfo.locationCode) || CHN_CODE
                    });
                }
            });
        }
    });
    return searchRegion;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/interface-region/dist/fuzzy/index.js
// module id = jJbp
// module chunks = 1